const NonSuccessIcon = (props: any) => {
  const { insideFill, ...otherProps } = props;
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox='0 0 124 123'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...otherProps}
    >
      <rect
        x='8.57188'
        y='26.5218'
        width='89.9437'
        height='89.9437'
        rx='24.2156'
        fill='#F53131'
        stroke='url(#paint0_linear_2905_8556)'
        strokeWidth='0.76875'
      />
      <g filter='url(#filter0_b_2905_8556)'>
        <rect
          x='25.0996'
          y='6.1499'
          width='90.7125'
          height='90.7125'
          rx='24.6'
          fill='url(#paint1_linear_2905_8556)'
          fillOpacity='0.7'
        />
        <rect
          x='25.484'
          y='6.53428'
          width='89.9437'
          height='89.9437'
          rx='24.2156'
          stroke='url(#paint2_linear_2905_8556)'
          strokeOpacity='0.9'
          strokeWidth='0.76875'
        />
      </g>
      <mask
        id='path-4-outside-1_2905_8556'
        maskUnits='userSpaceOnUse'
        x='50.5625'
        y='33.931'
        width='40'
        height='40'
        fill='black'
      >
        <rect fill='white' x='50.5625' y='33.931' width='40' height='40' />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M70.4558 60.7313L60.1731 71.0139C58.2033 72.9837 55.0096 72.9837 53.0398 71.0139C51.0701 69.0441 51.0701 65.8504 53.0398 63.8806L63.3225 53.598L53.2661 43.5416C51.2964 41.5719 51.2964 38.3782 53.2661 36.4084C55.2359 34.4386 58.4296 34.4386 60.3994 36.4084L70.4558 46.4647L80.5121 36.4084C82.4819 34.4386 85.6756 34.4386 87.6454 36.4084C89.6152 38.3782 89.6152 41.5719 87.6454 43.5416L77.589 53.598L87.8717 63.8806C89.8415 65.8504 89.8415 69.0441 87.8717 71.0139C85.9019 72.9837 82.7082 72.9837 80.7384 71.0139L70.4558 60.7313Z'
        />
      </mask>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M70.4558 60.7313L60.1731 71.0139C58.2033 72.9837 55.0096 72.9837 53.0398 71.0139C51.0701 69.0441 51.0701 65.8504 53.0398 63.8806L63.3225 53.598L53.2661 43.5416C51.2964 41.5719 51.2964 38.3782 53.2661 36.4084C55.2359 34.4386 58.4296 34.4386 60.3994 36.4084L70.4558 46.4647L80.5121 36.4084C82.4819 34.4386 85.6756 34.4386 87.6454 36.4084C89.6152 38.3782 89.6152 41.5719 87.6454 43.5416L77.589 53.598L87.8717 63.8806C89.8415 65.8504 89.8415 69.0441 87.8717 71.0139C85.9019 72.9837 82.7082 72.9837 80.7384 71.0139L70.4558 60.7313Z'
        fill='#F53131'
      />
      <path
        d='M60.1731 71.0139L59.6295 70.4703L60.1731 71.0139ZM70.4558 60.7313L70.9994 60.1877C70.6991 59.8875 70.2124 59.8875 69.9122 60.1877L70.4558 60.7313ZM53.0398 63.8806L52.4963 63.337H52.4963L53.0398 63.8806ZM63.3225 53.598L63.8661 54.1416C64.1663 53.8414 64.1663 53.3546 63.8661 53.0544L63.3225 53.598ZM53.2661 43.5416L53.8097 42.9981H53.8097L53.2661 43.5416ZM53.2661 36.4084L52.7226 35.8648L53.2661 36.4084ZM60.3994 36.4084L59.8558 36.952L60.3994 36.4084ZM70.4558 46.4647L69.9122 47.0083C70.2124 47.3085 70.6991 47.3085 70.9994 47.0083L70.4558 46.4647ZM80.5121 36.4084L79.9685 35.8648L80.5121 36.4084ZM87.6454 36.4084L87.1018 36.952L87.6454 36.4084ZM87.6454 43.5416L87.1018 42.9981L87.6454 43.5416ZM77.589 53.598L77.0454 53.0544C76.7452 53.3546 76.7452 53.8414 77.0454 54.1416L77.589 53.598ZM87.8717 63.8806L87.3281 64.4242L87.8717 63.8806ZM80.7384 71.0139L80.1948 71.5575H80.1948L80.7384 71.0139ZM60.7167 71.5575L70.9994 61.2749L69.9122 60.1877L59.6295 70.4703L60.7167 71.5575ZM52.4963 71.5575C54.7663 73.8275 58.4467 73.8275 60.7167 71.5575L59.6295 70.4703C57.9599 72.1399 55.253 72.1399 53.5834 70.4703L52.4963 71.5575ZM52.4963 63.337C50.2262 65.6071 50.2262 69.2875 52.4963 71.5575L53.5834 70.4703C51.9139 68.8007 51.9139 66.0938 53.5834 64.4242L52.4963 63.337ZM62.7789 53.0544L52.4963 63.337L53.5834 64.4242L63.8661 54.1416L62.7789 53.0544ZM63.8661 53.0544L53.8097 42.9981L52.7226 44.0852L62.7789 54.1416L63.8661 53.0544ZM53.8097 42.9981C52.1402 41.3285 52.1402 38.6215 53.8097 36.952L52.7226 35.8648C50.4525 38.1348 50.4525 41.8152 52.7226 44.0852L53.8097 42.9981ZM53.8097 36.952C55.4793 35.2824 58.1863 35.2824 59.8558 36.952L60.943 35.8648C58.673 33.5948 54.9926 33.5948 52.7226 35.8648L53.8097 36.952ZM59.8558 36.952L69.9122 47.0083L70.9994 45.9211L60.943 35.8648L59.8558 36.952ZM79.9685 35.8648L69.9122 45.9211L70.9994 47.0083L81.0557 36.952L79.9685 35.8648ZM88.189 35.8648C85.919 33.5948 82.2385 33.5948 79.9685 35.8648L81.0557 36.952C82.7253 35.2824 85.4322 35.2824 87.1018 36.952L88.189 35.8648ZM88.189 44.0852C90.459 41.8152 90.459 38.1348 88.189 35.8648L87.1018 36.952C88.7714 38.6215 88.7714 41.3285 87.1018 42.9981L88.189 44.0852ZM78.1326 54.1416L88.189 44.0852L87.1018 42.9981L77.0454 53.0544L78.1326 54.1416ZM77.0454 54.1416L87.3281 64.4242L88.4153 63.337L78.1326 53.0544L77.0454 54.1416ZM87.3281 64.4242C88.9977 66.0938 88.9977 68.8007 87.3281 70.4703L88.4153 71.5575C90.6853 69.2875 90.6853 65.6071 88.4153 63.337L87.3281 64.4242ZM87.3281 70.4703C85.6585 72.1399 82.9516 72.1399 81.282 70.4703L80.1948 71.5575C82.4648 73.8275 86.1453 73.8275 88.4153 71.5575L87.3281 70.4703ZM81.282 70.4703L70.9994 60.1877L69.9122 61.2749L80.1948 71.5575L81.282 70.4703Z'
        fill='url(#paint3_linear_2905_8556)'
        mask='url(#path-4-outside-1_2905_8556)'
      />
      <defs>
        <filter
          id='filter0_b_2905_8556'
          x='15.8746'
          y='-3.0751'
          width='109.163'
          height='109.163'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feGaussianBlur in='BackgroundImageFix' stdDeviation='4.6125' />
          <feComposite
            in2='SourceAlpha'
            operator='in'
            result='effect1_backgroundBlur_2905_8556'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_backgroundBlur_2905_8556'
            result='shape'
          />
        </filter>
        <linearGradient
          id='paint0_linear_2905_8556'
          x1='12.8'
          y1='31.5187'
          x2='90.4437'
          y2='120.694'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#F4C8CE' />
          <stop offset='1' stopColor='#E1586A' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_2905_8556'
          x1='25.0996'
          y1='6.1499'
          x2='115.812'
          y2='96.8624'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FEDCDD' />
          <stop offset='1' stopColor='#FFE3E6' />
        </linearGradient>
        <linearGradient
          id='paint2_linear_2905_8556'
          x1='29.7121'
          y1='11.5312'
          x2='107.356'
          y2='100.706'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#F4B7BF' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint3_linear_2905_8556'
          x1='62.8916'
          y1='11.5561'
          x2='105.111'
          y2='53.7755'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' />
          <stop offset='1' stopColor='white' stopOpacity='0' />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default NonSuccessIcon;
